import script from "./BannerDock.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerDock.vue?vue&type=script&setup=true&lang=js"

import "./BannerDock.vue?vue&type=style&index=0&id=fa0f7df2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa0f7df2"]])

export default __exports__